import { Injectable } from '@angular/core';
import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})
export class AhriService {

  constructor(
    private restful: RestfulService,
  ) { }

  // AHRI 리스트 정보 가져오기
  getAhriList( search: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'ahri',
        version: '1.0',
        action: 'getAhriList'
      }, search
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

   // 정보 저장하기
   setAhri( form ): Promise<any> {
    return this.restful.post({
        program: 'admin',
        service: 'ahri',
        version: '1.0',
        action: 'setAhri'
      }, form.value
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 정보 삭제하기
  deleteAhri( seq : any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'ahri',
        version: '1.0',
        action: 'deleteAhri'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }

  // 업로드 파일 삭제
  deleteUploadFile( seq: any ): Promise<any> {
    return this.restful.get({
        program: 'admin',
        service: 'ahri',
        version: '1.0',
        action: 'deleteUploadFile'
      }, {
        seq: seq
      }
    ).then(this.restful.extractData)
     .catch(this.restful.handleErrorPromise);
  }
}
